// Packages
import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment";

// Material Ui
import Popover from "@material-ui/core/Popover";
import "../../superAdmin/superAdmin.css";
import SchoolAdminDashboard from "../schoolAdminDashboard";

// Assets
import blankProfile from "../images/blank-profile.png";
import {
  resetGroupData,
  setSelectedGroupDetails,
} from "../../../Redux/Actions/GroupActions";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsPopup from "../../../Common/SettingsPopup";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { openConfirmationPopup } from "../../../Redux/Actions/PopupActions";
import { ContentLayoutSpinner } from "../../spinner/ContentLayoutSpinner";
import ContentLayoutDetailsHeader from "../../../Common/ContentLayoutDetailsHeader";
import { AiFillSetting } from "react-icons/ai";
import { MdModeEdit } from "react-icons/md";
import SchoolStatus from "../SchoolAdminPages/SchoolStatus/SchoolStatus";

function SchoolNameScreen() {
  const [anchorEl, setAnchorEl] = useState(null);
  const params = useParams();
  const groupId = params.groupId;
  const dispatch = useDispatch();
  const history = useHistory();
  const groupDetails = useSelector((state) => state.GroupsData?.selectedGroup);
  const loading = useSelector((state) => state.GroupsData?.loading);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );

  useEffect(() => {
    setSelectedGroupDetails(dispatch, { id: groupId });
    return () => {
      resetGroupData(dispatch, { status: true });
    };
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const statusCheck = () => {
    const status = groupDetails?.status ? false : true;
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: `Are You Sure You Want To ${
          status ? "Activate" : "Deactivate"
        } This Group?`,
        btnColor: "red",
        btnText: `${status ? "Activate" : "Deactivate"}`,
        type: "Activate Deactivate Group",
        id: groupId,
        status: status,
      },
    });
  };

  const deleteGroup = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: `Are You Sure You Want To Delete This Group?`,
        btnColor: "red",
        btnText: `Delete`,
        type: "Delete Group",
        id: groupId,
      },
    });
  };

  const settingList = [
    {
      icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
      name: "Delete Group",
      handleSubmit: deleteGroup,
    },
    {
      icon: groupDetails?.status ? (
        <DoDisturbOnIcon className="manage-section-iconss" />
      ) : (
        <CheckCircleIcon className="manage-section-iconss" />
      ),
      name: groupDetails?.status ? "Deactivate Group" : "Activate Group",
      handleSubmit: statusCheck,
    },
  ];

  const getTotalMemberCount = () => {
    return (
      groupDetails?.coachCount +
      groupDetails?.athleteCount +
      groupDetails?.teamAdminCount
    );
  };

  const headerIcons = [
    {
      id: 1,
      icon: <MdModeEdit className="header-icon" />,
      handleClick: () => history.push(`/editgroup/${groupId}`),
    },
    {
      id: 2,
      icon: <AiFillSetting className="header-icon" />,
      handleClick: handleClick,
    },
  ];

  return (
    <>
      <div
        // className="content-layout add-sectionn p-0 position-relative"
        className={
          isDrawerOpen
            ? "content-layout add-sectionn p-0 position-relative"
            : "toggle-content-layout add-sectionn p-0 position-relative"
        }
      >
        <SchoolAdminDashboard />
        <ContentLayoutSpinner animate={loading?.pageLoading} />
        <ContentLayoutDetailsHeader
          label="Group"
          name={groupDetails?.groupName}
          navigationLink="/groups"
          iconList={headerIcons}
        />
        <div>
          <div className="d-flex-space-between pd-20 flex-wrap light-grey-border">
            <div className="d-flex-align-cent gap-20">
              <img
                className="details-profile img-fluid"
                src={
                  groupDetails?.profilePhotoPath
                    ? groupDetails?.profilePhotoPath
                    : blankProfile
                }
                alt="PIC"
              />
              <div>
                <h4 className="fs-30 bold athlete-nm">
                  {groupDetails?.groupName}
                </h4>
              </div>
              <SchoolStatus
                status={groupDetails?.status && groupDetails?.status}
                isDeleted={false}
              />
            </div>
            <div className="" id="hoverCard">
              <div className="txt-center">
                <div className="white-card  border-grey h86 groupmember-box">
                  <label className="fs-20 semi-bold">
                    {getTotalMemberCount()}
                  </label>
                  <p className="fs-16 semi-bold">Members</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row px-2">
            <div className="col-12 col-lg-6 col-md-10  w-100 plr pt-1">
              <div className="clear10"></div>
              <div className="row p-1 ">
                <label className="fs-20 bold">Personal Information</label>
              </div>
              <div className="team-details fs-18">
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label className=""> Created By</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>{groupDetails?.createdBy}</p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label className="">Created At</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p className="">
                      {moment(groupDetails?.createdAt).format("MM/DD/YYYY")}
                    </p>
                  </div>
                </div>
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label className="">Status</label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    <p>
                      {groupDetails?.status === true ? "Active" : "Inactive"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="clear10"></div>
              <div className="team-details fs-18">
                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>
                      {groupDetails?.groupCoaches?.length > 1
                        ? "Coaches"
                        : "Coach"}
                    </label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    {groupDetails?.groupCoaches &&
                      groupDetails?.groupCoaches.map((data, index) => (
                        <p className=" mb-1">{data.name}</p>
                      ))}
                    {groupDetails?.groupCoaches?.length == 0 && "--"}
                  </div>
                </div>

                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label>
                      {groupDetails?.groupAthelets?.length > 1
                        ? "Athletes"
                        : "Athlete"}
                    </label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    {groupDetails?.groupAthelets &&
                      groupDetails?.groupAthelets.map((data, index) => (
                        <p className="mb-1">{data.name}</p>
                      ))}
                    {groupDetails?.groupAthelets?.length === 0 && "--"}
                  </div>
                </div>

                <div className="row p-1">
                  <div className="col-12 col-lg-4 col-md-4 fmlabel">
                    <label className="">
                      Team{" "}
                      {groupDetails?.groupTeamAdmins?.length > 1
                        ? "Admins"
                        : "Admin"}
                    </label>
                  </div>
                  <div className="col-12 col-lg-8 col-md-8">
                    {groupDetails?.groupTeamAdmins &&
                      groupDetails?.groupTeamAdmins.map((data, index) => (
                        <p className="mb-1">{data.name}</p>
                      ))}
                    {groupDetails?.groupTeamAdmins?.length === 0 && "--"}
                  </div>
                </div>
              </div>
              <div className="clear10"></div>
            </div>
          </div>
        </div>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <SettingsPopup settingList={settingList} />
        </Popover>
      </div>
    </>
  );
}

export default SchoolNameScreen;
